import { lazy, Suspense } from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { ViewportCenterCircle } from "@newComponents/common/ViewportCenterCircle";

const ESignPage = lazy(() => import("@newPages/sign/ESignPage"));
const ESignStatusPage = lazy(() => import("@newPages/myDocuments/ESignStatusPage"));

export function DocumentSignRoute() {
  const match = useRouteMatch();

  return (
    <Suspense fallback={<ViewportCenterCircle />}>
      <Switch>
        <Route exact path={`${match.url}`} component={ESignPage} />
        <Route exact path={`${match.url}/:documentSignId`} component={ESignStatusPage} />
        <Redirect from="*" to="/404?sn" />
      </Switch>
    </Suspense>
  );
}

DocumentSignRoute.defaultProps = {};
